import React, { createContext, useEffect, useState } from 'react';
import { MasterApi } from '../apis/MasterApi';

export type MasterType = {
  stations: Array<StationMasterType>;
};

export type StationMasterType = {
  station_no: string;
  latitude: number;
  longtitude: number;
  x_overview: number;
  y_overview: number;
  x_zoom: number;
  y_zoom: number;
  horizontal_flag_overview: boolean;
};

const initialState: MasterContextType = {
  master: {
    stations: []
  },
  failedGetMaster: false
};

type MasterContextType = {
  master: MasterType;
  failedGetMaster: boolean; //取得処理失敗フラグ
};

export const MasterContext = createContext({} as MasterContextType);

type Props = {
  children: React.ReactNode;
};

// マスターデータを取得～記憶するContext
export const MasterContextProvider: React.FC<Props> = (props) => {
  const [master, setMaster] = useState<MasterContextType>(initialState);

  useEffect(() => {
    const getApi = async () => {
      const res = await MasterApi();
      // console.log('🚀  マスター：APIデータ', res);
      if (res === null) {
        setMaster({
          master: { stations: [] },
          failedGetMaster: true
        });
        // console.log('マスター（ダミー）：加工後', {
        //   master: { stations: [] },
        //   failedGetMaster: true
        // });
      } else {
        setMaster(() => ({
          master: { stations: res.stations },
          failedGetMaster: false
        }));
        // console.log('マスター：加工後', {
        //   master: dummy_master,
        //   failedGetMaster: false
        // });
      }
    };

    getApi();
  }, []);

  return (
    <MasterContext.Provider
      value={{
        master: master.master,
        failedGetMaster: master.failedGetMaster
      }}
    >
      {props.children}
    </MasterContext.Provider>
  );
};
